/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Done_LogInputs */

const en_cook_done_log = /** @type {(inputs: Cook_Done_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log as cooked`)
};

const de_cook_done_log = /** @type {(inputs: Cook_Done_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als gekocht eintragen`)
};

/**
* | output |
* | --- |
* | "Log as cooked" |
*
* @param {Cook_Done_LogInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_done_log = /** @type {((inputs?: Cook_Done_LogInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Done_LogInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_done_log(inputs)
	return en_cook_done_log(inputs)
});